import { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './Modal.module.scss';
import type { ModalClassNameModifier } from './ModalClassNameModifiers';

type BodyProps = {
  children: React.ReactNode;
  classNameModifier?: ModalClassNameModifier;
};

const Body: FC<BodyProps> = ({ children, classNameModifier = '' }) => (
  <div className={getClassNames(styles, 'body', classNameModifier)}>{children}</div>
);

export default Body;
